module.exports = __webpack_public_path__ + "static/media/G1-22-Nohely-Kaligaris-cod53.38c622ba.png";